import { Box, Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ItemLabelRead } from 'components/UI/ItemLabelRead';
import { FunctionComponent } from 'react';
import { reduceResolution, wbp } from 'Theme';
import { VaccinesTableRow } from './VaccinesTableRow';
import { VaccineTableDisplayRow } from './pendingVaccineApprovals';

interface VaccinesTableProps {
    rows: VaccineTableDisplayRow[];
    onAccept: (approvalId: number) => Promise<void>;
    onDecline: (approvalId: number) => Promise<void>;
    canReviewApproval: (approvalId: number) => boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(13)}px !important`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '13px !important'
            }
        },
        containerVaccinesLabel: {
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        }
    })
);

export const VaccinesTable: FunctionComponent<VaccinesTableProps> = props => {
    const classes = useStyles();
    const hasAnyActions = props.rows.some(
        row => row.pendingApproval && props.canReviewApproval(row.pendingApproval.id)
    );

    return (
        <Box className={clsx(props.className)}>
            <Grid
                container
                className={classes.containerVaccinesLabel}
            >
                <Grid
                    item
                    xs={hasAnyActions ? 2 : 3}
                >
                    <ItemLabelRead
                        title="Vaccine"
                        classTitle={classes.header}
                    />
                </Grid>
                <Grid
                    item
                    xs={hasAnyActions ? 2 : 3}
                >
                    <ItemLabelRead
                        title="Expiration"
                        classTitle={classes.header}
                    />
                </Grid>
                <Grid
                    item
                    xs={hasAnyActions ? 3 : 4}
                >
                    <ItemLabelRead
                        title="Status"
                        classTitle={classes.header}
                    />
                </Grid>
                <Grid
                    item
                    xs={2}
                >
                    <ItemLabelRead
                        title="Records"
                        classTitle={classes.header}
                    />
                </Grid>
                {hasAnyActions && (
                    <Grid
                        item
                        xs={3}
                    />
                )}
            </Grid>
            <Grid container>
                {props.rows.map((row, index) => (
                    <VaccinesTableRow
                        key={row.key}
                        row={row}
                        last={index + 1 === props.rows.length}
                        hasActionsColumn={hasAnyActions}
                        canReview={row.pendingApproval ? props.canReviewApproval(row.pendingApproval.id) : false}
                        onAccept={props.onAccept}
                        onDecline={props.onDecline}
                    />
                ))}
            </Grid>
        </Box>
    );
};

export default VaccinesTable;
